import PropTypes from 'prop-types';
import React from 'react';

export default function FootballWinsDrawsWins(props) {
  const {
    homeTeamName,
    awayTeamName,
    homeWins,
    draws,
    awayWins
  } = props;

  require("./FootballWinsDrawsWins.scss");
  return (
    <div className="headToHead">
      <div className="teamA">
        <div className="teamAName">{homeTeamName}</div>
        <div className="big-number">{homeWins}</div>
        <div className="teamAAnnotation">Wins</div>
      </div>
      <div className="draws">
        <br />
        <div className="big-number">{draws}</div>
        <div className="drawsAnnotation">Draws</div>
      </div>
      <div className="teamB">
        <div className="teamBName">{awayTeamName}</div>
        <div className="big-number">{awayWins}</div>
        <div className="teamBAnnotation">Wins</div>
      </div>
    </div>
  );
}

FootballWinsDrawsWins.propTypes = {
  homeTeamName: PropTypes.string.isRequired,
  awayTeamName: PropTypes.string.isRequired,
  homeWins: PropTypes.number.isRequired,
  draws: PropTypes.number.isRequired,
  awayWins: PropTypes.number.isRequired

}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballWinsDrawsWins.js